import appStoreBadge from '@/assets/app-store-badge-white.svg';
import { APP_STORE_URL } from '@/lib/constants';
import { cn } from '@/lib/utils';

interface AppStoreBadgeProps {
  className?: string;
  /** Image height — defaults to "h-12" (~48px). */
  size?: string;
}

/**
 * "Download on the App Store" badge link.
 * The single source of truth for App Store CTAs across the marketing site.
 */
export function AppStoreBadge({ className, size = 'h-12' }: AppStoreBadgeProps) {
  return (
    <a
      href={APP_STORE_URL}
      target="_blank"
      rel="noopener noreferrer"
      className={cn('inline-block hover:opacity-80 transition-opacity', className)}
      aria-label="Download PodBrief on the App Store"
    >
      <img src={appStoreBadge} alt="Download on the App Store" className={cn('w-auto', size)} />
    </a>
  );
}
